import { useContext } from "react";
import { cleanDoubleSlashes, withQuery } from "ufo";

import { directusContext } from "~/shared/utils/directus/directus.provider";

export type ImageParams = {
  format?:
    | "jpg"
    | "jpeg"
    | "png"
    | "gif"
    | "webp"
    | "avif"
    | "svg"
    | "bmp"
    | "ico"
    | "tiff";
  height?: number;
  width?: number;
  fit?: "cover" | "contain" | "inside" | "outside";
  quality?: number;
  z?: string;
};

type UseDirectusOutput = {
  getDirectusImage: (imageId: ID, params?: ImageParams) => string;
};

const getDirectusImageUrl = (
  cmsPath: string,
  imageId: ID,
  params?: ImageParams,
): string => {
  const mergedParams: ImageParams = { format: "webp", ...params, z: ".img" };
  return cleanDoubleSlashes(
    withQuery(`${cmsPath}/cms-assets/${imageId}`, mergedParams ?? {}),
  );
};

export const useDirectus = (): UseDirectusOutput => {
  const context = useContext(directusContext);
  if (!context) {
    throw new Error("Context can't be null, please add directus provider");
  }

  const cmsPath = context.url;
  return {
    getDirectusImage: (imageId, params) => {
      return getDirectusImageUrl(cmsPath, imageId, params);
    },
  };
};
